import {
    createSlice,
    createAsyncThunk,
    createEntityAdapter,
} from '@reduxjs/toolkit'
import { client } from '../../api/client'

const activeVarsAdapter = createEntityAdapter({
    selectId: vars => vars.Id
})

const initialState = activeVarsAdapter.getInitialState({
    status: 'idle',
    error: null
})

export const fetchActiveVarsList = createAsyncThunk('vars/fetchActiveVars', async () => {
    const response = await client.get('/VarTransactions/GetActiveVarTransactions')
    return response.data
})

const activeVarsListSlice = createSlice({
    name: 'activeVars',
    initialState,
    reducers: {
        Reload(state) {
            activeVarsAdapter.removeAll(state)
            state.status = 'idle'
            state.error = null
        }
    },
    extraReducers: {
        [fetchActiveVarsList.pending]: (state, action) => {
            state.status = 'loading'
        },
        [fetchActiveVarsList.fulfilled]: (state, action) => {
            state.status = 'succeeded'
            state.reload = false
            activeVarsAdapter.addMany(state, action.payload)
        },
        [fetchActiveVarsList.rejected]: (state, action) => {
            state.status = 'failed'
            state.error = action.payload
        }
    }
})

export default activeVarsListSlice.reducer

export const {
    Reload
} = activeVarsListSlice.actions


export const {
    selectAll: selectAllActiveVars,
    selectById: selectActiveVarById,
    selectIds: selectActiveVarIds,
} = activeVarsAdapter.getSelectors((state) => state.activeVars)